export default "__VITE_ASSET__64f5232c__"